module.exports = __webpack_public_path__ + "img/p2.f78bafd3.png";